import { createContext } from 'react';

const historyContext = {
  callback: null,
  setCallback: (fn: () => void) => (historyContext.callback = fn),
};

export const HistoryContext = createContext(historyContext);
